import AdminPage from './pages/AdminPage'

export default function App() {
  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <AdminPage />
      </div>
    </div>
  )
}
